import { isString } from 'lodash-es'
import dayjs from 'dayjs'
import arraySupport from 'dayjs/plugin/arraySupport'

dayjs.extend(arraySupport)

export const dayjsInit = (time) => {
  if (!time) {
    return dayjs()
  }
  if (isString(time)) {
    return dayjs(time.replace(/-/g, '/').replace('T', ' '))
  }
  return dayjs(time)
}

export const getDateObject = (time) => {
  if (!time) return {}
  const dayjsValue = dayjs(time)
  const year = dayjsValue.get('year')
  const month = dayjsValue.get('month') + 1
  const date = dayjsValue.get('date')
  const hour = dayjsValue.get('hour')
  const minute = dayjsValue.get('minute')
  const second = dayjsValue.get('second')
  const millisecond = dayjsValue.get('millisecond')
  return {
    year,
    month,
    date,
    hour,
    minute,
    second,
    millisecond,
  }
}
